interface RefreshButtonProps {
  /** Normalmente o `refetch` do `useQuery` da listagem. */
  onRefresh: () => void;
  /**
   * `isFetching` da query. Desabilita o botão e gira o ícone enquanto a
   * requisição está em voo — sem isso, clicar repetido não dá retorno visual
   * nenhum (o React Query dedupa, então nada parece acontecer).
   */
  isRefreshing?: boolean;
}

/**
 * Refaz a request da listagem sem recarregar a página.
 *
 * Existe porque as listagens têm `staleTime` de minutos: dado que mudou no
 * backend (webhook processado, job rodado, ação de outro admin) não aparece até
 * a chave expirar. Antes disso a única saída era F5, que remonta o app inteiro
 * e perde filtro, página e aba.
 */
export function RefreshButton({
  onRefresh,
  isRefreshing = false,
}: RefreshButtonProps) {
  return (
    <button
      type="button"
      onClick={onRefresh}
      disabled={isRefreshing}
      aria-label="Atualizar"
      className="border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-bg-secondary) hover:text-(--color-text-primary) inline-flex shrink-0 items-center gap-2 rounded-lg border px-3 py-2.5 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50"
    >
      {/*
        Seta circular: arco de 270° em torno de (12,12) com raio 7, do topo
        (12,5) até a esquerda (5,12) no sentido horário — daí `large-arc` e
        `sweep` em 1. A ponta fecha em (5,12), onde a tangente do movimento
        horário aponta para cima.
      */}
      <svg
        className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 5A7 7 0 1 1 5 12"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.5 15.5 5 12l2.5 3.5"
        />
      </svg>
      <span>Atualizar</span>
    </button>
  );
}
